import { patchUser } from '../../services/user';
import signOutAction from './signOutAction';
import { USER_UPDATED } from './types';

const patchUserAction = (values) => async (dispatch) => {
  const { success, status, data } = await patchUser(values);
  if (success) {
    return dispatch({
      success: true,
      type: USER_UPDATED,
      payload: { user: data.profile }
    });
  } else {
    if (status == 401) {
      return dispatch(signOutAction);
    }
    return { success, status };
  }
};

export default patchUserAction;
